import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Snackbar, Alert, Button } from '@mui/material';

const PLATFORM = 'web_provider';
const BUILD_ID = process.env.REACT_APP_BUILD_ID || 'dev';
const APP_VERSION = process.env.REACT_APP_VERSION || '0.0.0';
const API_BASE = process.env.REACT_APP_API_BASE_URL || '/api';
const CHECK_INTERVAL_MS = 5 * 60 * 1000;

async function fetchConfig() {
  const params = new URLSearchParams({ platform: PLATFORM, currentVersion: APP_VERSION });
  const res = await fetch(`${API_BASE}/app-config/version?${params.toString()}`, {
    headers: { 'X-App-Version': APP_VERSION, 'X-Platform': PLATFORM },
  });
  if (!res.ok) throw new Error(`status ${res.status}`);
  return res.json();
}

const WebVersionGate = () => {
  const { t } = useTranslation();
  const [needsRefresh, setNeedsRefresh] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const check = async () => {
      try {
        const cfg = await fetchConfig();
        if (cancelled) return;
        if (cfg.webBuildId && cfg.webBuildId !== BUILD_ID) {
          setNeedsRefresh(true);
        }
      } catch (_) {}
    };
    check();
    const id = setInterval(check, CHECK_INTERVAL_MS);
    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, []);

  return (
    <Snackbar
      open={needsRefresh}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert
        severity="info"
        action={
          <Button
            color="inherit"
            size="small"
            onClick={() => window.location.reload()}
          >
            {t('version.refresh')}
          </Button>
        }
      >
        {t('version.newVersion')}
      </Alert>
    </Snackbar>
  );
};

export default WebVersionGate;
